import { render, staticRenderFns } from "./UserFieldsByGroupOverview.vue?vue&type=template&id=6f6255f4&scoped=true&"
import script from "./UserFieldsByGroupOverview.vue?vue&type=script&lang=js&"
export * from "./UserFieldsByGroupOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldsByGroupOverview.vue?vue&type=style&index=0&id=6f6255f4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6255f4",
  null
  
)

export default component.exports